import { useState, useEffect } from "react";
import styles from "../assets/styles/DivorceInsurance.module.css";
import LDU from "../assets/images/DivorceInsurance/ldu.png";
import LOn from "../assets/images/DivorceInsurance/lon.png";
import LOff from "../assets/images/DivorceInsurance/loff.png";
import ErrorImage from "../assets/images/DivorceInsurance/error.png";

export default function AskStarLoading() {
  const [imageData, setImageData] = useState("");

  useEffect(() => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const img = new Image();

    img.onload = () => {
      const viewportWidth = window.innerWidth;
      const maxWidth = 500;
      const imageWidth = Math.min(viewportWidth, maxWidth);
      const imageHeight = (imageWidth / img.width) * img.height;

      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0, img.width, img.height);

      let base64Image = canvas.toDataURL("image/png");
      setImageData(base64Image);
    };
    img.src = ErrorImage;
  }, []);

  return (
    <div className="letterContainer">
      <img src={imageData} alt="ldu" className={styles.letterCanvas} />
    </div>
  );
}
